/* Directional button fill.
   A brand-gold panel sweeps through the button on a diagonal: in from the top
   right on hover, and on out through the left when the pointer leaves. */
(function () {
  if (window.__personaButtonHover) return;
  window.__personaButtonHover = true;

  // The panel is skewed so its leading edge sweeps across on a diagonal. A
  // positive skew leans the top edge forward, so the sweep enters top-first.
  // It is oversized in CSS so the slanted ends still cover the corners.
  // Diagonal wipe driven by clip-path rather than a transform. Three attempts at
  // animating transform snapped on entry (measured: 0% -> 100% gold in a single
  // frame), so the panel now sits still and its clip is animated instead. The
  // 15% x-offset between the top and bottom points is what makes the edge
  // diagonal.
  var HIDDEN_RIGHT = 'polygon(115% 0%, 145% 0%, 130% 100%, 100% 100%)';
  var FULL = 'polygon(-15% 0%, 145% 0%, 130% 100%, -30% 100%)';
  var HIDDEN_LEFT = 'polygon(-45% 0%, -15% 0%, -30% 100%, -60% 100%)';

  function opaqueBackground(el) {
    var node = el;
    var hops = 0;
    while (node && node !== document.documentElement && hops < 30) {
      hops++;
      try {
        var bg = getComputedStyle(node).backgroundColor;
        if (bg && bg !== 'transparent' && !/rgba\(\s*0,\s*0,\s*0,\s*0\s*\)/.test(bg)) return bg;
      } catch (e) {
        break;
      }
      node = node.parentElement;
    }
    return '#ffffff';
  }

  function prepare(btn) {
    if (btn.dataset.hoverFill) return;
    if (btn.closest('[data-ppdp]') && btn.classList.contains('ppdp__atc')) return;
    btn.dataset.hoverFill = '1';

    var label = document.createElement('span');
    label.className = 'btn__label';
    while (btn.firstChild) label.appendChild(btn.firstChild);

    var fill = document.createElement('span');
    fill.className = 'btn__fill';
    fill.setAttribute('aria-hidden', 'true');
    fill.style.clipPath = HIDDEN_RIGHT;

    btn.appendChild(fill);
    btn.appendChild(label);

    // The label flips to the button's own background colour once covered.
    btn.style.setProperty('--btn-bg-capture', opaqueBackground(btn));

    // One continuous sweep: in from the top right, out through the left.
    var EASE = 'cubic-bezier(0.4, 0, 0.2, 1)';
    var DURATION = 420;
    var current = null;

    function run(from, to) {
      if (current) current.cancel();
      if (!fill.animate) {
        fill.style.clipPath = to; // no WAAPI: jump, but stay correct
        return;
      }
      // Do NOT pre-set the end state here. Writing it inline paints the final
      // frame immediately, which on entry looks exactly like an instant snap.
      // fill:'forwards' holds the end state once the animation finishes.
      current = fill.animate(
        [{ clipPath: from }, { clipPath: to }],
        { duration: DURATION, easing: EASE, fill: 'forwards' }
      );
    }

    function slideIn() {
      run(HIDDEN_RIGHT, FULL);
    }

    function slideOut() {
      run(FULL, HIDDEN_LEFT);
    }

    btn.addEventListener('mouseenter', slideIn);
    btn.addEventListener('mouseleave', slideOut);
    btn.addEventListener('focus', slideIn);
    btn.addEventListener('blur', slideOut);
  }

  // One bad element (app-injected buttons, shadow DOM, detached nodes) must not
  // abort the loop and leave every later button un-enhanced.
  function boot() {
    var nodes = document.querySelectorAll(
      '.button, .shopify-challenge__button, .p-btn, .pl-btn'
    );
    for (var i = 0; i < nodes.length; i++) {
      try {
        prepare(nodes[i]);
      } catch (e) {
        /* skip this button, keep going */
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
